<template>
  <section>
    <base-card v-if="preTournament">
      <h1>Pre-Season Picks for {{ currentSeason.year }} Season</h1>
      <div v-if="playersByNickname.length === 0">No one has made their picks yet...what are you waiting for?</div>
      <div v-else>
        <ol>
          <li v-for="player in playersByNickname" :key="player.userId">
            <div v-if="currentUserId === player.userId">
              "<a :href="userPickURL">{{ player.nickName }}</a
              >" {{ userNameByUserId(player.userId) }} (picks
              {{ player.picksComplete ? "complete" : "incomplete" }},
              {{ player.paid ? "paid" : "unpaid" }})
            </div>
            <div v-else>
              "{{ player.nickName }}" {{ userNameByUserId(player.userId) }} (picks
              {{ player.picksComplete ? "complete" : "incomplete" }},
              {{ player.paid ? "paid" : "unpaid" }})
            </div>
          </li>
        </ol>
      </div>
    </base-card>
    <base-card v-else>
      <h1>{{ currentSeason.year }} Season Standings:</h1>
      <div class="grid-list">
        <div class="grid-header">Place</div>
        <div class="grid-header">Player</div>
        <div v-for="week in currentWeek" :key="week" class="grid-header">
        <!-- <div v-for="week in 22" :key="week" class="grid-header"> -->
          <pre>{{ weekName(week) }}
({{ weekPoints(week) }} {{ weekPoints(week) === 1 ? "point" : "points" }})</pre>
        </div>
        <div class="grid-header">Total
        </div>
        <template
          v-for="(player, index) in playersByScore"
          :key="player.userId"
        >
          <div>{{ index + 1 }}</div>
          <div class="grid-player">{{ player.nickName }}</div>
          <div v-for="week in currentWeek" :key="week" :class="{ lowscore : lowScoreByWeek(week) === scoreByWeek(player.userId, week), highscore : highScoreByWeek(week) === scoreByWeek(player.userId, week) }">
          <!-- <div v-for="week in 22" :key="week" :class="{ highscore : highScoreByWeek(week) === scoreByWeek(player.userId, week) }"> -->
            {{ scoreByWeek(player.userId, week) }}
          </div>
          <div>{{ player.score }}</div>
        </template>
      </div>
    </base-card>
  </section>
</template>

<script>
export default {
  computed: {
    currentSeason() {
      return this.$store.getters["seasons/currentSeason"];
    },
    currentUserId() {
      return this.$store.getters.userId;
    },
    preTournament() {
      return this.currentSeason.tournamentPickingOpen === true;
    },
    playersByNickname() {
      console.group("playersByNickname");
      const playerList = this.$store.getters["picks/allPicksList"];
      console.info("playerList");
      console.table(playerList);
      console.groupEnd();
      return playerList.sort((a, b) => a.nickName > b.nickName);
    },
    userPickURL() {
      return "users/" + this.currentUserId + "/picks";
    },
    playersByScore() {
      const playerList = this.players;
      return playerList.sort((a, b) => (a.score > b.score ? -1 : 1));
    },
    currentWeek() {
      return this.$store.getters["schedules/currentWeek"];
    },
  },
  data() {
    return {
      players: [],
      postseasonWeekNames: ["W/C", "Div", "Conf", "SB"],
    };
  },
  beforeMount() {
    this.calculatePlayerScores();
  },
  methods: {
    userNameByUserId(userId) {
      console.group("userNameByUserId");
      var userName = "Unknown User";

      console.info("userId = ", userId);

      const usersList = this.$store.getters.userProfiles.filter((user) => {
        return user.userId === userId;
      });

      console.info("usersList (filtered)");
      console.table(usersList);

      if (usersList !== null && usersList.length === 1) {
        userName = usersList[0].userName;
      }

      console.info("returning userName = ", userName);
      console.groupEnd();
      return userName;
    },
    calculatePlayerScores() {
      const playerPicks = this.$store.getters["picks/allPicksList"];
      // userId: '',
      // nickName: '',
      // picksComplete: false,
      // picksList: [],
      const games = this.$store.getters["schedules/currentSchedule"];
      //   seasonId: 's1',
      //   weekNumber: 1,
      //   points: 1
      //   gameId: 1,
      //   home: null,
      //   visitor: null,
      //   winner: null,

      var i, j;
      var totalWeeks;

      this.players = [];
      for (i = 0; i < playerPicks.length; i++) {
        const player = new Object();
        player.userId = playerPicks[i].userId;
        player.nickName = playerPicks[i].nickName;
        player.score = 0;
        this.players.push(player);
      }

      for ( i = 0; i < games.length; i++ )
        if ( games[i].winner === null || games[i].winner === "" )
          break;

      // i = the first game of a new week (no games played this week), use the "new" week (use games[i]); scoreByWeek will just score zero for the last week
      // i = middle of a week (some games played), use the "new" week (use games[i]); scoreByWeek will score the partial week
      // i = games.length (all games played for the season), use the last game's weekNumber (use games[games.length-1])
      totalWeeks = (i < games.length) ? games[i].weekNumber : games[games.length-1].weekNumber;

      for ( i = 1; i <= totalWeeks; i++ ) {
        for ( j = 0; j < playerPicks.length; j++ ) {
          this.players[j].score += this.scoreByWeek(this.players[j].userId, i);
        }
      }
    },
    scoreByWeek(userId, week) {
      console.group("scoreByWeek");

      const season = this.$store.getters["seasons/currentSeason"];

      // get all games for this week
      const games = this.$store.getters["schedules/currentSchedule"].filter(
        (game) => {
          return game.weekNumber === week;
        }
      );

      // get all picks for this user
      const playerPicks = this.$store.getters["picks/allPicksList"].filter(
        (user) => {
          return user.userId === userId;
        }
      );

      var score = 0;

      // console.info("userId = ", userId);
      // console.info("week = ", week);
      // console.info("games.length = ", games.length);
      // console.table(games);
      // console.info("playerPicks.length = ", playerPicks.length);
      // console.table(playerPicks);

      for (var i = 0; i < games.length; i++) {
        if (games[i].winner !== null && games[i].winner !== "") {
          if ( week <= season.regularSeasonWeeks ) {
            // Regular season weeks (games should match picks by gameId)

            // for each game with a winner, check that game's gameId in player's pickslist to see if they picked the same team
            // Note: 'games' array only contains games for this week while picksList contains all picks for the season (picksList doesn't have "week", only gameId)
            if (games[i].winner === playerPicks[0].picksList[games[i].gameId - 1].winner) {
              score += games[i].points;
            }
          } else {
            // Playoff weeks (picks can match any winner)

            // for each game with a winner, check *all* this week's gameIds in playerPicks for a match
            // Note: 'games' array only contains games for this week while picksList contains all picks for the season (picksList doesn't have "week", only gameId)
            for (var j = 0; j < games.length; j++) {
              if (games[i].winner === playerPicks[0].picksList[games[j].gameId - 1].winner) {
                score += games[i].points;
                break;  // don't keep looking this week for this winner
              }
            }
          }
        }
      }

      console.info("userId = ", userId, "score = ", score);
      console.groupEnd();
      return score;
    },
    highScoreByWeek(week) {
      console.group("highScoreByWeek")
      const playerPicks = this.$store.getters["picks/allPicksList"];
      var highScore = 0;

      for (var i = 0; i < playerPicks.length; i++) {
        var playerScore = this.scoreByWeek(playerPicks[i].userId, week);

        if (playerScore > highScore) {
          highScore = playerScore;
        }
      }

      console.info("week = ", week, "highScore = ", highScore);
      console.groupEnd();
      return highScore;
    },
    lowScoreByWeek(week) {
      console.group("lowScoreByWeek")
      const playerPicks = this.$store.getters["picks/allPicksList"];
      var lowScore = null;

      for (var i = 0; i < playerPicks.length; i++) {
        var playerScore = this.scoreByWeek(playerPicks[i].userId, week);

        if ( lowScore === null ) {
          lowScore = playerScore;
        } else if (playerScore < lowScore) {
          lowScore = playerScore;
        }
      }

      console.info("week = ", week, "lowScore = ", lowScore);
      console.groupEnd();
      return lowScore;
    },
    weekName(week) {
      if (week >= 1 && week <= 18) {
        return "Week " + week;
      } else {
        return this.postseasonWeekNames[week - 19];
      }
    },
    weekPoints(week) {
      const schedule = this.$store.getters["schedules/currentSchedule"];
      const weekGames = schedule.filter((game) => {
        return game.weekNumber === week;
      });

      if (weekGames.length > 0) {
        return weekGames[0].points;
      } else {
        // error
        return 0;
      }
    },
  },
};
</script>

<style scoped>
.grid-list {
  display: grid;
  grid-template-columns: 1fr minmax(6rem, auto) repeat(v-bind(currentWeek), minmax(2rem, 1fr)) 1fr;
  /* grid-template-columns: 1fr minmax(6rem, auto) repeat(v-bind(22), minmax(2rem, 1fr)) 1fr; */
  justify-items: center;
  overflow-x: auto;
  font-size: 0.5rem;
}

.grid-header {
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  margin: 0 0.25rem;
}

.grid-player {
  justify-self: left;
}

.lowscore {
  color: red;
}

.highscore {
  color: green;
}

pre {
  white-space: pre-wrap; 
  word-wrap: break-word;
  font-family: inherit;
  margin: 0;
}

@media (min-width: 48rem) {
  .grid-list {
    grid-template-columns: 1fr minmax(12rem, auto) repeat(v-bind(currentWeek), minmax(5rem, 1fr)) 1fr;
    /* grid-template-columns: 1fr minmax(12rem, auto) repeat(v-bind(22), minmax(4rem, 1fr)) 1fr; */
    font-size: 1rem;
  }
}
</style>